import React, { Component } from 'react'
import PropTypes from 'prop-types'
import sortBy from 'sort-by'
import { Table, Column, Menu, Dropdown, Icon, Spin } from './common/Ant'
import { Anchor, ActionAnchor } from './common/Anchor'
import InputContainer from '../containers/common/InputContainer'
import { hasPermission } from '../utils/hasPermission'
import { createQueryString, parseQueryParams } from '../utils/queryParams'
import { DEFAULT_PAGE, DEFAULT_PER_PAGE, USER_PERMISSIONS } from '../constants'
import { configurePagination, escapeRegExp } from '../utils/helpers'

class AllCarriers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sortedInfo: {},
      data: this.props.carriers,
      searchText: '',
      page: DEFAULT_PAGE,
      perPage: DEFAULT_PER_PAGE,
    }
  }

  static propTypes = {
    carriers: PropTypes.arrayOf(PropTypes.object).isRequired,
    windowWidth: PropTypes.number.isRequired,
    meta: PropTypes.object,
    getAllCarriers: PropTypes.func,
    deleteCarrier: PropTypes.func,
    updateQueryParams: PropTypes.func,
    isCarrierLoading: PropTypes.bool,
  }

  componentWillReceiveProps(nextProps) {
    this.handleSearch()
  }

  componentDidMount() {
    const { page, perPage } = parseQueryParams(global.location)
    const { getAllCarriers } = this.props
    const query = {
      page: page ? parseInt(page, 10) : DEFAULT_PAGE,
      perPage: perPage ? parseInt(perPage, 10) : DEFAULT_PER_PAGE,
    }
    this.setState(query)
    getAllCarriers && getAllCarriers(createQueryString(query))
  }

  handleChange = (pagination, filters, sorter) => {
    const { getAllCarriers, updateQueryParams } = this.props
    const { page, perPage } = this.state

    if (page !== pagination.current) {
      const qs = createQueryString({ page: pagination.current, perPage })
      getAllCarriers && getAllCarriers(qs)

      updateQueryParams && updateQueryParams({ search: qs })
    }

    this.setState({
      page: pagination.current,
      sortedInfo: sorter,
      searchText: '',
    })
  }

  handlePerPageChange = perPage => {
    const { getAllCarriers, updateQueryParams } = this.props

    // a new page size can change the number of pages, so go back to the
    // first page so the API doesn't return a 404
    const qs = createQueryString({ page: DEFAULT_PAGE, perPage })
    this.setState({ page: DEFAULT_PAGE, perPage })
    getAllCarriers(qs)

    updateQueryParams && updateQueryParams({ search: qs })
  }

  handleInputChange = e => {
    this.setState({ searchText: e.currentTarget.value }, () =>
      this.handleSearch()
    )
  }

  handleSearch = () => {
    const { searchText } = this.state
    const regex = new RegExp(escapeRegExp(searchText), 'gi')

    this.setState((state, props) => ({
      data: props.carriers.filter(
        record => record.name && record.name.match(regex)
      ),
    }))
  }

  render() {
    const { deleteCarrier, meta, windowWidth, isCarrierLoading } = this.props
    const { data, sortedInfo, searchText, perPage } = this.state

    const isFixedColumn = windowWidth < 750
    const canEdit = hasPermission(USER_PERMISSIONS.EDIT_MODEM_AND_CARRIER)
    const canDelete = hasPermission(USER_PERMISSIONS.DELETE_MODEM_AND_CARRIER)

    return (
      <section className="mb5 AllCarriers">
        {hasPermission(USER_PERMISSIONS.ADD_MODEM_AND_CARRIER) && (
          <Anchor to="/inventory/carriers/create" className="mb3" button>
            Create New
          </Anchor>
        )}
        <div className="table-filter">
          <InputContainer
            input={{
              placeholder: 'Filter',
              value: searchText,
              onChange: this.handleInputChange,
            }}
          />
        </div>
        {isCarrierLoading ? (
          <Spin size="large" className="w-100 center mt5" />
        ) : (
          <Table
            dataSource={data}
            onChange={this.handleChange}
            rowKey="id"
            bordered
            pagination={configurePagination({
              perPage,
              onShowSizeChange: (page, perPage) =>
                this.handlePerPageChange(perPage),
              ...meta,
            })}
            tableLayout="auto"
          >
            <Column
              title="Name"
              dataIndex="name"
              sorter={sortBy('name')}
              sortOrder={sortedInfo.field === 'name' && sortedInfo.order}
              render={text => (text ? text : '--')}
            />
            {(canEdit || canDelete) && (
              <Column
                fixed={isFixedColumn ? 'right' : false}
                width={100}
                render={(text, record) => {
                  const menu = (
                    <Menu>
                      {canEdit && (
                        <Menu.Item key="edit-carrier">
                          <Anchor to={`/inventory/carriers/${record.id}/edit`}>
                            Edit
                          </Anchor>
                        </Menu.Item>
                      )}
                      {canDelete && (
                        <Menu.Item key="delete-carrier">
                          <ActionAnchor
                            onClick={() => deleteCarrier(record.id)}
                          >
                            Delete
                          </ActionAnchor>
                        </Menu.Item>
                      )}
                    </Menu>
                  )

                  return (
                    <Dropdown overlay={menu} trigger={['click']}>
                      <a className="ant-dropdown-link">
                        Actions <Icon type="down" />
                      </a>
                    </Dropdown>
                  )
                }}
              />
            )}
          </Table>
        )}
      </section>
    )
  }
}

export default AllCarriers
